import { TextFieldProps } from "@mui/material";

export const mulipleTextFieldSxStyles: TextFieldProps["sx"] = {
    "& .MuiInputBase-root": {
        paddingTop: "8px",
        "& .MuiChip-root": {
            top: "5.5px",
            marginTop: "0px",
            marginBottom: "0px",
        },
    },
};
